var storefrontApp = angular.module('storefrontApp');
storefrontApp.controller("brandsController",
    ["$rootScope", "$scope", "$document", "$window","$filter", "$location", "configs", "favoritesService", "randomService", "urlService", "favoritesElasticService", "commonService",
        function ($rootscope, $scope, $document, $window, $filter, $location, configs, favoritesService, randomService, urlService, favoritesElasticService, commonService) {

            $scope.$watch(
                function () {
                    return $scope.customer;
                },
                function (customer) {
                    getBrands();
                    getFavoriteBrands();
                }
            );

            function checkUserIsRegistered() {
                if ($scope.customer && $scope.customer.isRegisteredUser) {
                    return true;
                }
                return false;
            }

            $scope.updateFavoriteBrands = function (brandName) {
                if (checkUserIsRegistered()) {
                    var favBtnElement = null;
                    if (angular.isDefined(brandName)) {
                        favBtnElement = $document[0].getElementById("btn_favb_" + brandName);
                    }
                    else {
                        favBtnElement = $document[0].getElementById("btn_favb_" + brandName.toLowerCase().replace(/ /g, '_'));
                    }
                    if (angular.isDefined(favBtnElement)) {
                        favBtnElement.classList.add('loading');
                    }
                    var isFavorite = $scope.isFavoriteBrand(brandName);
                    if (isFavorite) {
                        favoritesService.removeBrandFromFavorites($scope.customer.contactId, brandName).then(function (response) {
                            getFavoriteBrands(true);
                            if (angular.isDefined(favBtnElement)) {
                                favBtnElement.classList.remove('loading');
                            }
                        })
                    }
                    else {
                        favoritesService.addBrandToFavorites($scope.customer.contactId, brandName).then(function (response) {
                            getFavoriteBrands(true);
                            if (angular.isDefined(favBtnElement)) {
                                favBtnElement.classList.remove('loading');
                            }
                        });
                    }
                }
                else {
                    var returnURL = $window.location.pathname + $window.location.search;
                    $scope.outerRedirect($scope.baseUrl + "account/login?returnurl=" + returnURL.replace("&", "%26"));
                }
            }

            $scope.isFavoriteBrand = function (brandName) {
                var isFavorite = false;
                if (checkUserIsRegistered()) {
                    angular.forEach($scope.favoritelistBrands, function (favoriteBrand) {
                        if (favoriteBrand.brandName == brandName) {
                            isFavorite = true;
                        }
                    });
                }
                return isFavorite
            }

            $scope.favoritesInitialize = function (prdType,fp) {
                $scope.productType = prdType;
                $scope.fp= (fp.toLowerCase() === 'true');
                $scope.options = {
                    showFavBrands: false,
                    showFavLists: true,
                    showFavItems: false
                };
                $rootscope.favoriteItems = [];
                $scope.favoriteBrands = [];
                $scope.searchText = '';
                $scope.listViewFilter = '';
                $scope.itemsPerPage = "10";

                $scope.pg = "1";
                $scope.pages = 3;
                $scope.brandIpp = 6;
                $scope.brandPg = "1";

            }      

            //#region get
            function getBrands() {
                $scope.pascalProductDefinition = $filter('productDefinitionFilter')($scope.productType);

                if ($scope.productType.toLowerCase() == 'printart' || $scope.productType.toLowerCase() == "vectorart") {
                    $scope.definition = "Vector Arts";
                    $scope.pascalProductDefinition = "PrintArt";
                }
                else if ($scope.productType.toLowerCase() == "fontletter") {
                    $scope.definition = "Font Letters";
                    $scope.pascalProductDefinition = "FontLetter";
                }
                else if ($scope.productType.toLowerCase() == "designs" || $scope.productType.toLowerCase() == "stockdesign") {
                    $scope.definition = "Designs";
                    $scope.pascalProductDefinition = "StockDesign";
                }
                else if ($scope.productType.toLowerCase() == "designpack" || $scope.productType.toLowerCase() == "packs") {
                    $scope.definition = "Design Packs";
                    $scope.pascalProductDefinition = "DesignPack";
                }
                else {    
                    $scope.definition = $filter('pluralProductType')($filter('getProductType')($scope.productType));
                } 
                commonService.getElasticData(
                    configs.elasticBaseUrl,
                    favoritesElasticService.buildBrands($scope.pascalProductDefinition, $scope.fp)
                ).then(
                    function (response) {
                        $scope.favoriteBrands = response.data.aggregations.brands.buckets;

                        if($scope.fp){
                            var filteredbrandlistings =$scope.favoriteBrands.filter(function(brand){
                                return brand.doc_count > 10;
                            })

                            $scope.favoriteBrands = filteredbrandlistings;
                        }
                        if (angular.isDefined($scope.options) && $scope.favoriteBrands.length > 0) {
                            getBrandUrls();
                            getBrandDefinitions();
                            getFavoriteBrands();
                        }
                    }
                )

            }

            function getFavoriteBrands() {
                if (checkUserIsRegistered()) {
                    favoritesService.getFavoriteBrands($scope.customer.contactId).then(function (response) {
                        $scope.favoritelistBrands = response.data;
                    });
                }
            }

            function getBrandDefinitions() {
                var allBrands = _.pluck($scope.favoriteBrands, 'key').join('","');
                commonService.getElasticData(
                    configs.elasticBaseUrl,
                    favoritesElasticService.buildBrandDefinitionsInfoRequest(allBrands, $scope.favoriteBrands.length,$scope.fp)
                ).then(
                    function (response) {
                        if (response && response.data && response.data.aggregations) {
                            $scope.brandDefinitions = response.data.aggregations.groupbyBrands.buckets;
                            commonService.getElasticData(
                                configs.elasticBaseUrl,
                                favoritesElasticService.buildBrandSampleInfoRequest(allBrands, $scope.favoriteBrands.length,$scope.fp)
                            ).then(
                                function (response) {
                                    if (response && response.data && response.data.aggregations) {
                                        $scope.brandSampleItems = response.data.aggregations.groupbyBrands.buckets;
                                        angular.forEach($scope.favoriteBrands, function (brand) {
                                            brand.samples = [];
                                            brand.definitions = [];
                                            var brandSamples = $scope.brandSampleItems.filter(function (s) {
                                                return s.key.toLowerCase() == brand.key.toLowerCase()
                                            })[0];
                                            brandSamples = angular.isDefined(brandSamples) ? brandSamples.groupbyBrands.hits.hits : [];
                                            var brandDefinitions = $scope.brandDefinitions.filter(function (d) {
                                                return d.key.toLowerCase() == brand.key.toLowerCase()
                                            })[0];
                                            brandDefinitions = angular.isDefined(brandDefinitions) ? brandDefinitions.groupbyDef.buckets : [];
                                            if (window.__env.noisePrdDefs !== undefined && window.__env.noisePrdDefs !== null) {
                                                brandDefinitions = brandDefinitions.filter(function (definition) {
                                                    var itemToFilter = definition.key.toLowerCase();
                                                    return window.__env.noisePrdDefs.indexOf(itemToFilter) === -1;
                                                });
                                            }
                                            brand.definitions.push(brandDefinitions);
                                            brand.samples.push(
                                                randomService.getRandomItems(brandSamples, 4)
                                            );
                                        });
                                    }
                                }
                            );
                        }
                    }
                );
            }

            $scope.getImageUrl = function (definitionName, vendor, prdId) {
                vendor = vendor.replace(/ /g, "_");
                return urlService.getImageUrl(definitionName, "medium", vendor, "", "", prdId.split(/-(.+)/)[1]);

            }

            $scope.getProductUrl = function (definitionName, vendor, name, itemId) {
                return urlService.getProductUrl(definitionName, vendor, name, itemId);
            }

            $scope.getBrandDefinitionUrl = function (brand, definition) {
                if (angular.isDefined(brand) && angular.isDefined(definition)) {
                    brand = brand.toLowerCase();
                    definition = definition.toLowerCase();
                    var definitionKeyword = "";
                    if (definition == 'stockdesign') {
                        definitionKeyword = "designs";
                    }
                    else if (definition == 'fontletter') {
                        definitionKeyword = "fontletter";
                    }
                    else if (definition == 'designpack') {
                        definitionKeyword = "packs";
                    }
                    else {
                        definitionKeyword = definition;
                    }
                    if($scope.fp)
                        return '/brands/'+ brand + '/' +'free-embroidery-designs';
                    else
                    return '/brands/' + brand + '/' + definitionKeyword;
                }
            }
            function getBrandUrls() {
                if($scope.favoriteBrands && $scope.favoriteBrands.length > 0){
                    $scope.favoriteBrands.forEach(function(brand){
                        var pageUrl="";      
                        pageUrl += 'brands/'+brand.key.toLowerCase().replace(/ /g, "-");
                        pageUrl += ($scope.fp ? '/free-embroidery-designs' : '/all');
                        brand.pageUrl=pageUrl;
                    })
                }
            }
        }
    ]);
